module.exports = __webpack_public_path__ + "img/logo-white.97bc0b0f.png";